import s from '../collegesItem.module.css'
import {useEffect, useState} from "react";

import {Button, Select} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import { usersAPI, directionAPI } from "@api"
import { InputSelect, InputNew } from "@UI/InputNew";
import { useLoad } from "@/hooks/useLoad";
import { useInputNew } from "@UI/InputNew/useInputNew";

const ModalAddDirection = ({userId, subjects, setActive, update}) => {
  const addAlert = useAddAlert();
  const [loading, setLoading] = useState(false);


  const getParams = () => {
    if (subjects?.length) {
      return {
        filter: [
          `[direction_id][nin][]=${subjects?.map(
            ({ id }) => id
          )}`,
        ],
      };
    }
    return;
  };

  const { state: directionList } = useLoad({
    api: directionAPI.getAll,
    params: { ...getParams() },
    initState: [],
    key: "data",
  });

  const [direction, setDirection] = useState("");
  const [bindDirection] = useInputNew({
    name: "direction",
    value: direction,
    onChange: setDirection,
    placeholder: "Выберите направление",
    errorText: "Не выбрано направление",
    options: directionList?.map(({ id: value, name: label }) => ({
      label,
      value,
    })),
    style: { width: "100%" },
  });

  const save = () => {
    if (direction) {
      setLoading(true)
      usersAPI
          .addDirection({
            data: { direction_id: direction, seminarian_id: userId },
          })
          .then((res) => {
            if (res.data.status === "success") {
              update("direction")
              addAlert({ title: "Направление успешно добавлено" });
              setActive(false)
            }
          })
          .finally((res)=>{
            setLoading(true);
          });
    } else {
      addAlert({ type: "error", title: "Не выбрано направление" });
    }
  };
 
  return <div className="modal_departments">
    <h2 className="modal__title">Добавить направление</h2>
    <div className={s.body}>
        <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Выберите направление</span>
        <InputSelect {...bindDirection} />
        <Button disabled={loading} onClick={save}>Добавить</Button>
    </div>
  </div>
}
export default ModalAddDirection